(function () {

    angular.module('BuscaAtivaEscolar').directive('alertCasesWithoutAssignedUser', function (Platform, Reports, Identity) {

        function init(scope) {

            scope.data = {};

            var searchData = {
                view: 'linear',
                entity: 'children',
                dimension: 'assigned_user_status',
                filters: {
                    case_status: ['in_progress'],
                    alert_status: ['accepted'],
                    case_not_info: null
                },
                group: {
                    tree: 1,
                    tenant_id: Identity.getCurrentUser().tenant_id,
                    group_id: Identity.getCurrentUser().group_id
                }
            };

            Platform.whenReady(function () {
                Reports.query_aggregation_children(searchData, function (data) {
                    scope.data = data;
                });
            });

        }

        return {
            link: init,
            replace: true,
            templateUrl: '/views/components/alert_cases_without_assigned_user.html'
        };
    });

})();